import { makeMonthsArray } from './utils';

export const MONTHS_ARRAY = makeMonthsArray();
